import { Pipe, PipeTransform } from "@angular/core";
import { NgxTranslateService } from "../shared/ngx-translate.service";

@Pipe({
  name: "notificationheader"
})
export class NotificationHeadersPipe implements PipeTransform {
  constructor(private translateService : NgxTranslateService){

  }
  transform(value: string, args: any[]): any {
    switch (value) {
      case "Text":
        return this.translateService.getText('Notification_TextSMS', "Text(SMS)");
      case "Mobile":
        return this.translateService.getText('Notification_MobileApp', "Mobile App");
      case "InApp":
        return this.translateService.getText('Notification_Inapp', "In-app");
      default:
        return this.translateService.getText('Notification_Email', "Email");;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/notification/notificationHeader.pipe.ts